if (!customElements.get('attrbt-swipe-row')) {
  customElements.define(
    'attrbt-swipe-row',
    class AttrbtSwipeRow extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('ul');
        this.update = this.update.bind(this);
        this.list.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.list);
        this.update();
      }

      disconnectedCallback() {
        this.list?.removeEventListener('scroll', this.update);
        this.resizeObserver?.disconnect();
      }

      // Thumb width shows how much of the row is visible; its offset follows the swipe
      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.list;
        const size = scrollWidth > 0 ? Math.min(100, (clientWidth / scrollWidth) * 100) : 100;
        const maxScroll = Math.max(1, scrollWidth - clientWidth);
        const offset = (scrollLeft / maxScroll) * ((100 - size) / size) * 100;
        this.style.setProperty('--attrbt-progress-size', `${size}%`);
        this.style.setProperty('--attrbt-progress-offset', `${offset}%`);
      }
    }
  );
}
